import { ThemingParameters } from '@ui5/webcomponents-react-base';
import "@ui5/webcomponents/dist/Assets.js";
import "@ui5/webcomponents-fiori/dist/Assets.js";
import {
    FlexBox,
    FlexBoxAlignItems,
    FlexBoxDirection,
    Text,
    Panel,
    Grid,
    Title,
    Button,
    Link
} from '@ui5/webcomponents-react';
import './App.css';
import { useNavigate } from "react-router-dom";

export function Home() {

    const navigate = useNavigate();
    const handleGoToButton = () => { navigate("/main");};

    return (
        <>

            <Grid
                style={{
                    backgroundColor: ThemingParameters.sapBackgroundColor,
                    

                }}
            >


                <Panel
                    data-layout-indent="XL3 L2 M2 S0"
                    data-layout-span="XL6 L8 M8 S12"

                    style={{
                        backgroundColor: ThemingParameters.sapBaseColor
                    }}
                    headerText="Willkommen"
                >
                <br />
                    <Text  >
                        {"Herzlichen willkommen zum Entspar Simulator des Behavioral Finance e.V. \n \n Hier geht es um die Frage, wie Sie Ihr angespartes Vermögen über einen gewissen Zeitraum aufbrauchen (konsumieren) können. Konkret: Wie lange reichen Ihre Ersparnisse? Wie viel können Sie sich leisten? Wie stark kann der Konsum schwanken? \n \n Unser Tool erlaubt es, verschiedene Entsparstrategien zu simulieren. Sie können die zugrundeliegenden Annahmen anpassen und ändern, um ein Gefühl für die Auswirkungen auf die Ergebnisse zu bekommen. Dazu müssen Sie nur einige wenige Fragen beantworten und schon kann es losgehen. \n \n Eine ausführliche Erklärung zum Entspartool finden Sie im Annex zu unserem Behavioral Finance Band 01 auf "  } <Link href="https://www.behavioral-finance.de" target="_blank" rel="noreferrer">www.behavioral-finance.de </Link>
                    </Text>
                    <br />
                    <br />
                    <br />
                    <FlexBox style={{ width: '100%' }}
                        direction={FlexBoxDirection.Column}
                        alignItems={FlexBoxAlignItems.Center}>
                        <Button style={{ width: "60%" }} onClick={handleGoToButton}>Zum Entspar Simulator</Button>
                    </FlexBox>
                    <br />
                </Panel>
            </Grid>
            <Grid
                style={{
                    backgroundColor: ThemingParameters.sapBackgroundColor,

                }}
            >
                <Panel
                    data-layout-indent="XL3 L2 M2 S0"
                    data-layout-span="XL6 L8 M8 S12"
                    collapsed="true"
                    style={{
                        backgroundColor: ThemingParameters.sapBaseColor
                    }}
                    headerText="Details zur Methodik"
                >
<br />
                    
                    <Text  >
                        {"Die Simulation der Entnahmestrategien und alle darauf aufbauenden Berechnungen basieren auf einem Monte-Carlo Simulationsansatz. Dieser Ansatz ist ein mathematisches Verfahren, das zur Schätzung der möglichen Ergebnisse eines ungewissen Ereignisses verwendet wird. In unserem Fall ist das ungewisse Ereignis wie sich der Kapitalmarkt über eine bestimmte Zeit entwickelt, denn davon hängt letztendlich ab, wie sich Ihr Vermögen und Ihr Konsum entwickeln wird. Wir betrachten für jede Entnahmestrategie in jeder Ausgestaltungsform, wie sich der Konsum in 20.000 unabhängigen Kapitalmarktszenarien entwickelt hätte und vergleichen die Ergebnisse. \n \n Wichtig: Auch wenn wir mit unserer Simulation eine große Bandbreite an möglichen Kapitalmarktentwicklungen abdecken, bleibt die Zukunft dennoch ungewiss. Die Simulation basiert auf historischen Kapitalmarktdaten und die Welt in 5, 10 oder 20 Jahren kann eine andere sein, als in den Vergangenen 30 Jahren. Trotzdem hilft uns unsere Simulation dabei einige allgemeingültige Ergebnisse zu formulieren sowie ein besseres Gefühl für die Chancen und Risiken der verschiedenen Entnahmestrategien zu bekommen."}</Text>
                    <br />
                    <br />
                    <br />
                    <Title level="H4" >
                        Kapitalmarktsimulation
                    </Title>
                    <br />
                    <Text  >
                        {"Um die Marktentwicklung simulieren zu können, nutzen wir historische Kapitalmarktdaten. Wir gehen von einem breit diversifiziertem Aktien- und Anleihenportfolio aus. Die genaue Aufteilung beträgt 60% Aktien und 40% Anleihen (wir bezeichnen dieses Portfolio ab jetzt als 60/40-Basisportfolio). Konkret liegt dem Portfolio der MSCI All Country World Index (Aktien) und der Bloomberg Barclays Global Aggregate Bond Index (Anleihen) zugrunde. Dividenden und Zinserträge wurden berücksichtigt. Um die Wertentwicklung des Portfolios zu simulieren, werden die monatlichen Renditen des 60/40-Basisportfolios für den Zeitraum Januar 1990 – Ende 2022 berechnet. Aus diesem „Renditetopf“ werden anschließend monatliche Renditen zufällig (mit zurücklegen) gezogen, und zwar genau so viele, wie wir für Ihren Planungshorizont benötigen. Planen Sie zum Beispiel mit 20 Jahren, dann werden 20 x 12 = 240 Renditen gezogen und so eine Entwicklung des Kapitalmarktes simuliert. Nun können wir, wenn wir die Entwicklung genau einmal simulieren Glück oder Pech haben. Vielleicht werden zufällig nur sehr gute Renditen aus unserem Topf gezogen und unser Portfolio entwickelt sich prächtig. Vielleicht ist aber auch das Gegenteil der Fall und es läuft eher schlecht. Eine einmalige Simulation liefert daher keine verlässlichen Ergebnisse. Wenn wir aber mehrere Simulationen durchführen bekommen wir ein realistisches Bild. Die Monte-Carlo Simulation ermöglicht diese realistischere Einschätzung der zukünftigen Entwicklung, indem Sie eine Vielzahl möglicher Marktszenarien betrachtet. Anstatt die Berechnungen auf eine einzige Simulation zu stützen, erstellen wir 20.000 Simulationen hypothetischer Marktszenarien und berechnen die Auswirkungen auf Ihre Ersparnisse während Ihres Ruhestands. Jede Simulation umfasst Aufwärts- und Abwärtsmärkte von unterschiedlicher Dauer, Intensität und Kombination."}          </Text>
                    <br />
                    <br />
                    <br />
                    <Title level="H4" >
                    Entsparstrategien
                    </Title>
                    <br />
                    <Text  >
                        {"Unser Simulator erlaubt die Wahl zwischen zwei Entnahme-Strategien, nämlich der X%-Entnahme und der Dynamischen Entnahme."}
                    </Text>
                    <br />
                    <br />
                    <Title level="H5" className="textUnderlined">
                    X%-Entnahme:
                    </Title>
                    <br />
                    <Text  >
                        {"Diese Strategie hat das Ziel einen konstanten Konsum über den Planungshorizont zu ermöglichen. Die Regel ist nicht kompliziert: Am Anfang jeder Periode (z.B. jedes Jahres) wird ein konstanter realer (also Inflationsadjustierter) Betrag aus dem Portfolio entnommen. Durch die Inflation müssen wir jede Periode ein wenig mehr entnehmen, damit unsere Konsummöglichkeiten auch wirklich konstant bleiben.\n\n Beispiel: Wenn Sie 500.000 Euro über 20 Jahre entsparen möchten und in der Simulation die Entnahme auf 5% stellen, dann bedeutet das, dass Sie im ersten Jahr 25.000 Euro entnehmen und diesen Betrag jedes Jahr um die Inflationsrate (1,5%) steigern. Im zweiten Jahr also 25.000 x 1,015 = 25.375 Euro. Im dritten Jahr 25.755,63 Euro und so weiter."}</Text>
                    <br />
                    <br />
                    <Title level="H5" className="textUnderlined">
                    Dynamische-Entnahme:
                    </Title>
                    <br />
                    <Text  >
                        {"Diese Strategie hat die Ziele, dass das Vermögen zum einen über den gesamten Planungshorizont ausreicht und zum anderen am Ende des Planungshorizonts auch wirklich aufgebraucht ist. Diese Ziele können durch eine dynamische Anpassung der Entnahme erreicht werden. Einfach ausgedrückt: läuft der Kapitalmarkt gut entnehme ich mehr, läuft er schlecht entnehme ich weniger. Der Konsum wird also nicht in jeder Periode gleich sein, sondern schwanken. Wer möchte kann diese Schwankungen etwas reduzieren, indem eine Obergrenze für den Konsum festgelegt wird. Läuft der Kapitalmarkt super, entnehmen wir mit Obergrenze trotzdem ein bisschen weniger als wir könnten und behalten den Rest für Zeiten in denen der Kapitalmarkt nicht so gut läuft. Stellen Sie im Simulator einfach mal verschiedene Obergrenzen ein und schauen, wie diese Sich auf den Konsum und dessen Schwankung auswirken."}</Text>
                </Panel>

            </Grid>
     



        </>
    );
}

